// Função pura para detectar a base da rota (empresa | cliente) a partir da URL.
// Mantida em um módulo isolado, SEM importar a store, para evitar dependência
// circular (auxiliar -> store -> app-config/auth -> baseRoute) que gerava o erro
// "Cannot access 'baseRoute' before initialization" na inicialização da store.
export const baseRoute = () => {
    const path = window.location.pathname;
    const bases = path.split('/');
    const base = [ 'empresa', 'cliente' ].includes(bases[2]) ? bases[2] : 'empresa';

    return base;
}
